import { isEmpty, isNil } from 'lodash';
import { API } from '@shared/types/api';

interface UseIsNeverEnabledProps {
  minimumInSeries?: number;
  tagFilter?: API.FilterByComponentFragment;
}

export function useIsNeverEnabled({ minimumInSeries, tagFilter }: UseIsNeverEnabledProps): boolean {
  const hasTagFilter = !isEmpty(tagFilter?.componentId);

  return !isNil(minimumInSeries) && hasTagFilter;
}
